<template>
    <v-dialog
      v-model="renameDialog"
      persistent
      max-width="350"
    >
      <v-card v-if="channel">
        <v-card-title class="text-h5">
          <span>{{$t('chat.renameChannel.title')}} <span :class="getTextColor">{{ channelName }}</span>?</span>
        </v-card-title>
        <br/>
        <v-card-text>
          <v-dialog
            v-model="emojiOpen"
            width="325"
          >
            <VEmojiPicker @select="emojiSelector"/>
          </v-dialog>
          <div class="d-flex">
            <div class="d-flex flex-column" v-if="showEmoji">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    class="mr-2 mt-4"
                    @click="openEmojiDialog()"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>
                      mdi-emoticon-happy-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>Pick an emoji</span>
              </v-tooltip>
            </div>
            <v-text-field
              required
              v-model="name"
              counter
              maxlength="22"
              :hint="$t('chat.newConversation.errors.specialCharacters')"
              :label="$t('chat.newConversation.channelName')"
              clearable
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeDialog()"
          >
            {{$t('chat.renameChannel.btn.cancel')}}
          </v-btn>
          <v-btn
            :color="getColor"
            text
            :disabled="name.length==0"
            class="rename-channel-dialog-btn"
            @click="submit()"
          >
            {{$t('chat.renameChannel.btn.submit')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { VEmojiPicker } from 'v-emoji-picker'

export default {
  name: 'chat-renameChannelDialog',
  data () {
    return {
      name: '',
      emojiOpen: false,
      showEmoji: false // rocketchat wont let us use emoji in channels name
    }
  },
  components: {
    VEmojiPicker
  },
  computed: {
    ...mapGetters({
      renameDialog: 'chat/openRenameChannelDialog',
      channel: 'chat/contextMenuChannel'
    }),
    channelName: function () {
      return this.channel?.formatName()
    },
    getColor: function () {
      return this.channel?.conversationColorScheme()
    },
    getTextColor: function () {
      return `font-weight-bold ${this.getColor}--text`
    }
  },
  watch: {
    channelName: function (val) {
      this.name = val
    },
    name (val) {
      this.name = val?.replace(/[^A-Z0-9]+/ig, '-')
    }
  },
  methods: {
    ...mapActions({
      closeDialog: 'chat/openRenameChannelDialog',
      renameChannel: 'chat/renameChannel'
    }),

    openEmojiDialog () {
      this.emojiOpen = !this.emojiOpen
    },

    emojiSelector (emoji) {
      this.name = this.name + emoji.data
      this.openEmojiDialog()
    },

    submit () {
      this.renameChannel(this.name)
    }
  }
}
</script>

<style scoped>
</style>
